/** Matches ViewportContainer frame resize transition duration. */
export const VIEWPORT_TRANSITION_MS = 300;
